import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

function buildPageNumbers(currentPage, totalPages) {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, 5];
  }

  if (currentPage >= totalPages - 2) {
    return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  return [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2];
}

function Pagination({ pagination, onPageChange }) {
  const { total, page, limit, totalPages, hasPrevPage, hasNextPage } = pagination;

  const from  = (page - 1) * limit + 1;
  const to    = Math.min(page * limit, total);
  const pages = buildPageNumbers(page, totalPages);

  return (
    <div className="pagination">

      <span className="pagination-info">
        Affichage de {from} à {to} sur {total} entrées
      </span>

      <div className="pagination-controls">
        <button
          className="pagination-btn"
          onClick={() => onPageChange(page - 1)}
          disabled={!hasPrevPage}
          aria-label="Page précédente"
        >
          <ChevronLeft size={14} />
        </button>

        {pages.map(num => (
          <button
            key={num}
            className={`pagination-btn ${page === num ? 'active' : ''}`}
            onClick={() => onPageChange(num)}
          >
            {num}
          </button>
        ))}

        <button
          className="pagination-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={!hasNextPage}
          aria-label="Page suivante"
        >
          <ChevronRight size={14} />
        </button>
      </div>

    </div>
  );
}

export default Pagination;
